import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type DevToolsState = {
  showDeveloperFeatures: boolean;
};

const initialState: DevToolsState = {
  showDeveloperFeatures: false,
};

const devToolsSlice = createSlice({
  name: 'dev-tools',
  initialState,
  reducers: {
    setShowDeveloperFeatures: (state, action: PayloadAction<boolean>) => {
      state.showDeveloperFeatures = action.payload;
    },
  },
});

export const { setShowDeveloperFeatures } = devToolsSlice.actions;
export const devToolsReducer = devToolsSlice.reducer;
